import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SearchTypeahead } from '@bambi/component-library/src/components/SearchTypeahead/SearchTypeahead';
import { Route, Routes } from 'react-router';

import { AddPricingSchemeButton } from './AddPricingSchemeButton';
import { onClearFilters, setPricingSearchTerm } from './pricing.slice';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';

export function PricingRouteActions() {
  const dispatch = useAppDispatch();
  const {
    pricingSearchTerm,
    selectedPayers,
    selectedSpaceTypes,
    selectedServiceTypes,
  } = useAppSelector((state) => state.pricing);

  const { inputValue, handleInputChange } = useDebouncedSearch(
    setPricingSearchTerm,
    pricingSearchTerm
  );

  const hasFilters =
    !!selectedPayers.length ||
    !!selectedSpaceTypes.length ||
    !!selectedServiceTypes.length;

  return (
    <Routes>
      <Route
        index
        element={
          <div className="flex gap-4">
            {hasFilters && (
              <Button
                onClick={() => dispatch(onClearFilters())}
                variant="anchor"
                className="whitespace-nowrap"
                dataTestId="clear-filters-button"
              >
                clear filters
              </Button>
            )}
            <SearchTypeahead
              dataTestId="pricing-search"
              onChange={handleInputChange}
              placeholder="Search pricing schemes"
              value={inputValue}
            />
            <AddPricingSchemeButton />
          </div>
        }
      />
    </Routes>
  );
}
